import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import echarts from 'echarts'

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'
import axios from 'axios'
import '@/icons' // icon
import '@/permission' // permission control
import './utils/error-log' // error log
import * as filters from './filters' // global filters
// 引入Leaflet对象 挂载到Vue上，便于全局使用，也可以单独页面中单独引用
import * as L from 'leaflet'
import 'proj4leaflet'
import 'leaflet.chinatmsproviders'
import '@/directive/throttle-debounce'
import '@/directive/prevent-re-click'
import '@/directive/tenant'
import _ from 'lodash'
import Base from './base'
import global from './plugins/global'
import VueLazyload from 'vue-lazyload'

Vue.use(global)
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
// if (process.env.NODE_ENV === 'production') {
//   const { mockXHR } = require('../mock')
//   mockXHR()
// }

// set ElementUI lang to EN
// 如果想要中文版 element-ui，按如下方式声明
Vue.use(ElementUI)
Vue.prototype.$echart = echarts

Vue.mixin(Base)
Vue.config.productionTip = false
window.busMaps = {}
window.L = L
window._ = _
window.Horizon = {
  basePath: '//' + process.env.VUE_APP_DEV_API.split('/')[2] + '/horizon'
}
// register global utility filters
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})
// Vue.component('alert', require('./components/Alert.vue').default)
// Vue.prototype.$bus = new Vue()
Vue.prototype.$http = axios.create()
const loadimage = require('./assets/images/loading.gif')
const errorimage = require('./assets/images/404.png')

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: errorimage,
  loading: loadimage,
  attempt: 1
})
new Vue({
  el: '#app',
  router,
  store,
  beforeCreate() {
    Vue.prototype.$bus = this
  },
  render: (h) => h(App)
})
